import InformationToggle from './InformationToggle';

export default InformationToggle;
